// GENERATED FILE - DO NOT MODIFY

export enum UpdateTeamMembersActionDto {
    Add = "Add",
    Remove = "Remove",
}